import { ICategory, ICategoryFormValues } from "../entities/category.entity";

export interface CategoriesState {
    data: CategoriesDataState;
    ui: CategoriesUiState;
}

export interface CategoriesDataState {
    categories: ICategory[];
    categoryBackup: ICategoryFormValues;
    saveChanges: CategorySaveChanges;
}

export interface CategorySaveChanges {
    show: boolean;
    path?: string;
}   

export interface CategoriesUiState {
    loading: boolean;
    loadingDelete: boolean;
}

export const initialState: CategoriesState = {
    data: {
        categories: [],
        categoryBackup: {} as ICategoryFormValues,
        saveChanges: {
            show: false,
            path: ""
        }
    },
    ui: {
        loading: false,
        loadingDelete: false
    }
}